import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faAngleDoubleDown,
    faAngleDoubleUp,
    faBars,
    faBolt,
    faBookmark,
    faCalendarTimes,
    faCheck,
    faClock,
    faCloudUploadAlt,
    faCog,
    faCopy,
    faDatabase,
    faDesktop,
    faEdit,
    faExclamationTriangle,
    faExternalLinkAlt,
    faPlus,
    faSave,
    faSearch,
    faSignOutAlt,
    faTimes,
    faTrash,
} from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { MsalProvider } from '@azure/msal-react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import context from './context';
import './index.css';
import configureRedux from './Redux/configureRedux';
import configureStore from './Redux/configureStore';
import configureServices from './Services';
import AppAuth from './Components/AppAuth';

library.add(
    faAngleDoubleDown,
    faAngleDoubleUp,
    faBars,
    faBolt,
    faBookmark,
    faCalendarTimes,
    faCheck,
    faCloudUploadAlt,
    faCog,
    faCopy,
    faDatabase,
    faDesktop,
    faEdit,
    faExclamationTriangle,
    faPlus,
    faSave,
    faTimes,
    faTrash,
    faExternalLinkAlt,
    faSignOutAlt,
    faClock,
    faSearch
);

const render = async (store, authService, settingsService) => {
    const target = document.getElementById('root');
    const msalClientScopeURL = settingsService.GetMsalClientScope();
    const msalApplication = authService.msalApplication;
    
    ReactDOM.render(
        <MsalProvider instance={msalApplication}>
            <Provider store={store}>
                <Router>
                    <AppAuth msalClientScope={msalClientScopeURL} />
                </Router>
            </Provider>
        </MsalProvider>,
        target
    );
};

// Initialize services and react-redux app with dependency injection
(async function init() {
    const services = await configureServices();
    const { actions, reducers } = await configureRedux(services);

    context.registerServices(services);
    context.registerActions(actions);

    render(configureStore(reducers), services.auth, services.appSettings);
})();
